import styled from "styled-components"

export const CancelButtonWrapper = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-top: 16px;
`
export const SubmitForm = styled.div`
    margin-top: 50px;
`
export const SubmitButton = styled.div<{
    disabled?: boolean
}>`
    height: 38px;
    width: 100%;
    line-height: 36px;
    text-align: center;
    padding: 0 15px;
    margin-top: 16px;
    border-radius: 2px;
    white-space: nowrap;
    font-size: 15px;
    font-family: ${(props) => props.theme.openSans};
    font-weight: 600;
    text-transform: uppercase;
    user-select: none;
    cursor: pointer;
    opacity: ${(props) => (props.disabled ? 0.55 : 1)};
    pointer-events: ${(props) => (props.disabled ? "none" : "all")};
    background: ${(props) => props.theme.checkoutButtonBackground};
    color: ${(props) => props.theme.checkoutButtonColor};
    
    & > i {
        font-size: 24px;
        line-height: 38px;
        color: inherit;
    }
`
